import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconFont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#59805c',
        secondary: '#1565C0',
        required : '#A94442',
        success: '#3C763D',
        error: '#DE534F',
        nobirad:"#ffffff",
        birad0:"#84aae6",
        birad1:"#80a39c",
        birad2:"#89d08b",
        birad3:"#c4e36e",
        birad4:"#fffd3f",
        birad4a:"#fadf32",
        birad4b:"#fdc939",
        birad4c:"#e19037",
        birad5:"#ea7a3d",
        birad6:"#fe4228",
      },
      dark: {
        primary: '#59805c',
        secondary: '#1565C0',
        required : '#A94442',
        success: '#3C763D',
        error: '#DE534F',
        nobirad:"#000000",
        birad0:"#84aae6",
        birad1:"#80a39c",
        birad2:"#89d08b",
        birad3:"#c4e36e",
        birad4:"#fffd3f",
        birad4a:"#fadf32",
        birad4b:"#fdc939",
        birad4c:"#e19037",
        birad5:"#ea7a3d",
        birad6:"#fe4228",
      },
    },
  },
});

// Colores SUIM
// #1f5630
// #398abe
// #92c2bf
// #343a40